import { env } from 'src/app/services/PlugpointEnvironment';
// src/app/services/auth.config.ts
// PROD
export const AUTH_CONFIG = env =="prod" ? {
  clientID: 'yi4Wi2lJs53TyIyyNJFGMDAjZomMp26L',
  clientId: 'yi4Wi2lJs53TyIyyNJFGMDAjZomMp26L',
  domain: 'login.plugpoint.ro',
  domainAPI: 'login.plugpoint.ro',
  packageIdentifier: 'com.gobreazy.app', // config.xml widget ID, e.g., com.auth0.ionic
  audience: 'https://plugway.eu.auth0.com/api/v2/',
}: {
  clientID: 'SOoRwbK6pC4eedgBmOqpxutZ85Lo9HAK',
  clientId: 'SOoRwbK6pC4eedgBmOqpxutZ85Lo9HAK',
  domain: 'plugpoint.eu.auth0.com',
  domainAPI: 'plugpoint.eu.auth0.com',
  packageIdentifier: 'com.gobreazy.app', // config.xml widget ID, e.g., com.auth0.ionic
  audience: 'https://plugpoint.eu.auth0.com/api/v2/',
};

export const auth0Config = {
  domain: AUTH_CONFIG.domain,
  clientId: AUTH_CONFIG.clientId,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: AUTH_CONFIG.audience,
    scope: 'openid profile email',
  },
};
